import script from "./MobileChat.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileChat.vue?vue&type=script&setup=true&lang=js"

import "./MobileChat.vue?vue&type=style&index=0&id=319fe452&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319fe452"]])

export default __exports__